const Loader=()=>(
    <div className='loader-page'>
        <div id="loader"></div>
        </div>
)
export default Loader;